import { Hero } from './Hero';
import { TrustLogos } from './TrustLogos';
import { PricingSection } from './PricingSection';
import { ProblemSection } from './ProblemSection';
import { SolutionPillars } from './SolutionPillars';
import { Features } from './Features';
import { HowItWorks } from './HowItWorks';
import { UseCases } from './UseCases';
import { Differentiation } from './Differentiation';
import { Metrics } from './Metrics';
import { FinalCTA } from './FinalCTA';

/**
 * The pre-Phase 11 home page, preserved verbatim at /legacy-home so we can compare against
 * the new marketing-style HomePage and roll back quickly if needed. Section composition is
 * unchanged from the old inline definition in App.tsx.
 */
export const LegacyHomePage = ({ onHiringStart }: { onHiringStart: () => void }) => (
  <div className="min-h-screen">
    <Hero onHiringStart={onHiringStart} />
    <TrustLogos />
    <PricingSection />
    <ProblemSection />
    <SolutionPillars />
    <Features />
    <HowItWorks />
    <UseCases />
    <Differentiation />
    <Metrics />
    <FinalCTA onHiringStart={onHiringStart} />
  </div>
);
